import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Table } from "antd";
import { BeatLoader } from "react-spinners";
// import Pagination from '../../Pagination';
import Skeleton from "react-loading-skeleton";
import DatePicker from "react-datepicker";
import { Tooltip } from "antd";
import AddMaster from "./AddMaster";
import Select from 'react-select';
import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../Config';
// import { DesignationApi } from '../../../Redux/action/MasterAction';
import { Code } from "@mui/icons-material";
import ReactTooltip from "react-tooltip";
import Reg from "./General/Reg";
import ShipperTab from "./General/ShipperTab";
import Consignee from "./General/Consignee";
import ServicesTab from "./General/ServicesTab";
import Iata from "./General/SubTab/Iata";
import Carrier from "./General/SubTab/Carrier";
import Agent from "./General/SubTab/Agent";
import { adminMainUrl } from "../../../../Config";
import { DesignationApi } from "../../../../Redux/action/MasterAction";

// import { DesignationApi } from '../../../../Redux/action/MasterAction';
// import { adminMainUrl } from '../../../../Config';

const CarrierBookingForm = ({ accessedModules, accessedPermission }) => {
  const [currentData, setCurrentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [dataOffset, setDataOffset] = useState(0);
  const dataPerPage = 10;
  const [reload, setReload] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [DesignationName, setDesignationName] = useState(null);
  const [DesignationId, setDesignationId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  // const { name } = useParams();
  const dispatch = useDispatch();
  const {
    loadingDesignationTypeApi,
    findDesignationTypeData,
    findDesignationTypeDataError,
  } = useSelector((state) => state?.MasterReducer);
  useEffect(() => {
    dispatch(DesignationApi(adminMainUrl));
  }, [adminMainUrl, reload]);
  const handleSuccess = () => {
    // Toggle reload to trigger useEffect
    setReload((prev) => !prev);
  };

  // Initialize Formik
  const statusChange = async (id) => {
    setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/designation/status-change`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSpinnerLoader(false);
        handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    // if (accessedPermission.includes("state_change_master_data")) {
    statusChange(id);
    // }
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = findDesignationTypeData?.data;

  const totalPages = Math.ceil(
    findDesignationTypeData?.data?.length / itemsPerPage
  );

  // Function to change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Function for "Next" and "Previous" buttons
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const arr = new Array(5).fill(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  // const columns = [
  //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
  //     { title: "Date", dataIndex: "date", key: "date" },
  //     { title: "Name", dataIndex: "name", key: "name" },
  //     { title: "Email", dataIndex: "email", key: "email" },
  //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
  //     { title: "Origin", dataIndex: "origin", key: "origin" },
  //     { title: "Destination", dataIndex: "destination", key: "destination" },
  //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
  //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
  //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
  //     { title: "Action", dataIndex: "action", key: "action" },
  // ];
  const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Code", dataIndex: "Code", key: "Code" },
    { title: "Prefix", dataIndex: "Prefix", key: "Prefix" },
    { title: "CheckDigit", dataIndex: "CheckDigit", key: "CheckDigit" },
    { title: "Account No", dataIndex: "AccountNo", key: "AccountNo" },
    { title: "Home Page URL", dataIndex: "HomePageURL", key: "HomePageURL" },
    { title: "Tracking URL", dataIndex: "TrackingURL", key: "TrackingURL" },
    { title: "Status", dataIndex: "Status", key: "Status" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      Name: "Commission", // Ensure date formatting as neede
      Code: "ChargeCategory",
      Prefix: "Applicable",
      CheckDigit: "Charge",
      AccountNo: "AE",
      HomePageURL: "xyz",
      TrackingURL: "xyz",
      Status: (
        <>
          <span
            className={`cursor-pointer  badge badge-pill badge-status bg-success   `}
          >
            Active
          </span>

          {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
        </>
      ),
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div
              className="dropdown-item cursor-pointer"
              onClick={handleEditShow}
            >
              <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      Name: "Commission", // Ensure date formatting as neede
      Code: "ChargeCategory",
      Prefix: "Applicable",
      CheckDigit: "Charge",
      AccountNo: "AE",
      HomePageURL: "xyz",
      TrackingURL: "xyz",
      Status: (
        <>
          <span
            className={`cursor-pointer  badge badge-pill badge-status bg-danger   `}
          >
            Inactive
          </span>

          {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
        </>
      ),
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div
              className="dropdown-item cursor-pointer"
              onClick={handleEditShow}
            >
              <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>
          </div>
        </div>
      ),
    },
  ];
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <div className="row">
                        <div className="col-md-12">
                           
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Organization List<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div> */}
          <div className="card">
            <div className="card-body">
              {/* Filter */}
              <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="" className="form-label mb-0">
                      Reference No.
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="search_by"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                      Date
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      {/* <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span> */}
                      <div className="custom-datepicker">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                        />
                        <span style={{ top: "13px" }}>
                          <img src="/img/date.png" alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                      Source
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      {/* <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span> */}
                      <Select
                            className="custom-selector"
                          />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                      Job Ref. No.
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="search_by"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Service Provider
                    </label>
                    <div className="  mb-3 mb-sm-0">
                    <Select
                            className="custom-selector"
                          />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Service Provider
                    </label>
                    <div className="  mb-3 mb-sm-0">
                    <Select
                            className="custom-selector"
                          />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Current Status
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="search_by"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Carrier Booking Ref.
                    </label>
                    <div className="  mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="search_by"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Booking Type
                    </label>
                    <div className="  mb-3 mb-sm-0">
                    <Select
                            className="custom-selector"
                          />
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label htmlFor="" className="form-label  mb-0">
                    Delivery type 
                    </label>
                    <div className="  mb-3 mb-sm-0">
                    <Select
                            className="custom-selector"
                          />
                    </div>
                  </div>

                  {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                </div>
                
              </div>
              {/* /Filter */}
              {/* Contact List */}

              {/* {
                                loadingDesignationTypeApi ?
                                    arr.map((value, index) => {
                                        return (

                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <BeatLoader />
                                        </div>
                                        )
                                    }) :
                                    spinnerLoader ?
                                        <>
                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                <BeatLoader />
                                            </div>
                                        </> :
                                        <> */}
              <div className="row-gap-2 mt-4">
                <ul
                  className="nav nav-pills mb-3 custom-tabs gap-0"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Reg-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Reg"
                      type="button"
                      role="tab"
                      aria-controls="Reg"
                      aria-selected="false"
                    >
                      Entities
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Shipper-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Shipper"
                      type="button"
                      role="tab"
                      aria-controls="Shipper"
                      aria-selected="false"
                    >
                      Shipment Info
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Consignee-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Consignee"
                      type="button"
                      role="tab"
                      aria-controls="Consignee"
                      aria-selected="false"
                    >
                      Goods Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Agent-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Agent"
                      type="button"
                      role="tab"
                      aria-controls="Agent"
                      aria-selected="false"
                    >
                      Container Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Service-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Service"
                      type="button"
                      role="tab"
                      aria-controls="Service"
                      aria-selected="false"
                    >
                      Other Info
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Carrier-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#Carrier"
                      type="button"
                      role="tab"
                      aria-controls="Carrier"
                      aria-selected="false"
                    >
                      History
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  {/* <div className="tab-pane fade show active" id="General" role="tabpanel" aria-labelledby="General-tab">
                                        <GeneralTab />
                                    </div> */}
                  <div
                    className="tab-pane fade"
                    id="Reg"
                    role="tabpanel"
                    aria-labelledby="Reg-tab"
                  >
                    <Reg />{" "}
                    {/* <BuyerInProgessOrdersContent InProgressOrdersData={InProgressOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Shipper"
                    role="tabpanel"
                    aria-labelledby="Shipper-tab"
                  >
                    <ShipperTab />{" "}
                    {/* <BuyerInProgessOrdersContent InProgressOrdersData={InProgressOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Consignee"
                    role="tabpanel"
                    aria-labelledby="Consignee-tab"
                  >
                    <Consignee />{" "}
                    {/* <BuyerCompletedOrdersContent CompletedOrdersData={CompletedOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Agent"
                    role="tabpanel"
                    aria-labelledby="Agent-tab"
                  >
                    <Agent />{" "}
                    {/* <BuyerCancelledOrdersContent CancelledOrdersData={CancelledOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Service"
                    role="tabpanel"
                    aria-labelledby="Service-tab"
                  >
                    <ServicesTab />{" "}
                    {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                  </div>

                  {/* <div className="tab-pane fade" id="Account-info" role="tabpanel" aria-labelledby="Account-info-tab">
                                        <AccountInfo />
                                    </div> */}
                  <div
                    className="tab-pane fade"
                    id="Billing"
                    role="tabpanel"
                    aria-labelledby="Billing-tab"
                  >
                    5{" "}
                    {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Carrier"
                    role="tabpanel"
                    aria-labelledby="Carrier-tab"
                  >
                    <Carrier />{" "}
                    {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="IATA"
                    role="tabpanel"
                    aria-labelledby="IATA-tab"
                  >
                    <Iata />{" "}
                    {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                  </div>
                </div>
              </div>

              {/* <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                                        </>
                            } */}
              {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
      <AddMaster
        show={addShow}
        handleClose={handleAddClose}
        onSuccess={handleSuccess}
      />
      <EditMaster
        show={editshow}
        handleClose={handleEditClose}
        onSuccess={handleSuccess}
      />
      {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
      {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
    </>
  );
};

export default CarrierBookingForm;
